import "./Layout.scss";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { FaGreaterThan, FaLessThan } from "react-icons/fa";
import { CiMenuBurger } from "react-icons/ci";
import UserProfile from "./UserProfile";
import { ImCross } from "react-icons/im";
import { FaCircleUser } from "react-icons/fa6";
import { MdDashboard } from "react-icons/md";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { INSERT_ACCESS } from "../../_contstants/common";
import { LiaInfoSolid } from "react-icons/lia";
import IconComponent from "../common/IconComponent";
import { SiHiveBlockchain } from "react-icons/si";

export const menuData = [
  {
    key: "dashboard",
    title: "Dashboard",
    icon: <IconComponent icon={MdDashboard} />,
    quickMenu: [],
    sections: [],
  },

  {
    key: "inquiry",
    title: "Inquiry",
    icon: <IconComponent icon={LiaInfoSolid} />,
    quickMenu: [],
    sections: [],
  },
  {
    key: "inquiries",
    title: "Inquiries",
    icon: <IconComponent icon={LiaInfoSolid} />,
    quickMenu: [],
    sections: [],
  },
  {
    key: "masters",
    title: "Masters",
    icon: <IconComponent icon={SiHiveBlockchain} />,
    quickMenu: [
      {
        title: "Doctor",
        key: "doctor",
      },
      {
        title: "Hospital",
        key: "hospital",
      },
    ],
    sections: [
      {
        title: "Website",
        children: [
          {
            title: "Banner",
            key: "banner",
          },
          {
            title: "Blog",
            key: "blog",
          },
          {
            title: "Testimonial",
            key: "testimonial",
          },
          {
            title: "Seo Tag",
            key: "seotag",
          },
          {
            title: "Settings",
            key: "setting",
          },
          {
            title: "CMS",
            key: "cms",
          },
          {
            title: "FAQ",
            key: "faq",
          },
          {
            title: "Video",
            key: "video",
          },
        ],
      },
      {
        title: "Property",
        children: [
          {
            title: "Service",
            key: "service",
          },
          {
            title: "Research",
            key: "research",
          },
          {
            title: "Property Type",
            key: "propertytype",
          },
          {
            title: "Property Status",
            key: "propertystatus",
          },
          {
            title: "Project",
            key: "project",
          },
        ],
      },
      {
        title: "Place",
        children: [
          {
            title: "Region",
            key: "region",
          },
          {
            title: "Country",
            key: "country",
          },
          {
            title: "State",
            key: "state",
          },
          {
            title: "City",
            key: "city",
          },
          {
            title: "Area",
            key: "area",
          },
        ],
      },
    ],
  },
  {
    key: "usermanagement",
    title: "User Management",
    icon: <IconComponent icon={FaCircleUser} />,
    quickMenu: [
      { title: "User", key: "user/create" },
      { title: "User Type", key: "usertype/create" },
    ],
    sections: [
      {
        title: "Masters",
        children: [
          { title: "User", key: "user" },
          { title: "User Type", key: "usertype" },
        ],
      },
    ],
  },
  // {
  //   key: "webintegrations",
  //   title: "Web Integrations",
  //   icon: <IconComponent icon={TbWorldWww} />,
  //   quickMenu: [],
  //   sections: [
  //     {
  //       title: "Website",
  //       children: [
  //         {
  //           title: "Banner",
  //           key: "banner",
  //         },
  //         {
  //           title: "Blog",
  //           key: "blog",
  //         },
  //         {
  //           title: "Testimonial",
  //           key: "testimonial",
  //         },
  //         {
  //           title: "Seo Tag",
  //           key: "seotag",
  //         },
  //         {
  //           title: "Setting",
  //           key: "setting",
  //         },
  //         {
  //           title: "CMS",
  //           key: "cms",
  //         },
  //         {
  //           title: "FAQ",
  //           key: "faq",
  //         },
  //         {
  //           title: "Facilities",
  //           key: "facilities",
  //         },
  //         {
  //           title: "Why Choose",
  //           key: "whychoose",
  //         },
  //         {
  //           title: "Amenities",
  //           key: "amenities",
  //         },
  //         {
  //           title: "Tour Type",
  //           key: "tourtype",
  //         },
  //         {
  //           title: "Activities",
  //           key: "activities",
  //         },
  //         {
  //           title: "Attractions",
  //           key: "attractions",
  //         },
  //         {
  //           title: "Gallery",
  //           key: "gallery",
  //         },
  //         {
  //           title: "Room",
  //           key: "room",
  //         },
  //         {
  //           title: "Degree",
  //           key: "degree",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMasterUser = localStorage.getItem("IsMasterUser") === "true";

  const MENUNAME = [
    "dashboard",
    "contact",
    "lead",
    "inquiry",
    "quotation",
    "fitbooking",
    "tourbooking",
    "booking",
  ];

  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userRights: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userRights = JSON.parse(userResponseString);
  } catch (error) {
    userRights = [];
  }

  const filterMenuByUserRights = (menuData: any, userRights: any) => {
    const hasRight = (key: string) => {
      if (key.includes("/create")) {
        const baseKey = key.replace("/create", "");
        const userMenu = userRights?.find(
          (menu: any) => menu.MenuKey === baseKey,
        );
        return (
          userMenu && userMenu.RightsID.split(", ").includes(INSERT_ACCESS)
        );
      } else {
        return userRights?.some((menu: any) => menu.MenuKey === key);
      }
    };

    return menuData
      .map((menu: any) => {
        const mainMenuHasRight = hasRight(menu.key);

        if (!mainMenuHasRight) return null;

        const filteredQuickMenu = menu.quickMenu.filter((item: any) =>
          hasRight(item.key),
        );
        const filteredSections = menu.sections
          .map((section: any) => {
            const filteredChildren = section.children.filter((child: any) =>
              hasRight(child.key),
            );
            return { ...section, children: filteredChildren };
          })
          .filter((section: any) => section.children.length > 0);
        if (
          hasRight(menu.key) ||
          filteredQuickMenu.length > 0 ||
          filteredSections.length > 0
        ) {
          return {
            ...menu,
            quickMenu: filteredQuickMenu,
            sections: filteredSections,
          };
        }
        return null;
      })
      .filter((menu: any) => menu !== null);
  };

  const filteredMenus = filterMenuByUserRights(menuData, userRights);

  const usermanagementIndex = filteredMenus.findIndex(
    (item: any) => item.key === "usermanagement",
  );
  if (usermanagementIndex !== -1 && isMasterUser) {
    filteredMenus[usermanagementIndex].sections[0].children.push(
      { title: "Menu", key: "menu" },
      { title: "Rights", key: "rights" },
      { title: "Organization Info", key: "organization" },
    );
  }

  const { pathname } = location;
  const baseKey = pathname?.split("/").filter(Boolean)[0] || "";

  const toggleMenu = () => {
    document.querySelectorAll(".navbar-nav > li").forEach((element) => {
      element.addEventListener("click", function (this: HTMLElement) {
        document.querySelector(".page-contect")?.classList.remove("in");
        document.querySelectorAll(".navbar-nav > li").forEach((li) => {
          li.classList.remove("active");
          const popup = document.querySelector(
            ".navbar-nav > li.active .subnav-content",
          );
          if (popup) {
            const popupElement = popup as HTMLElement;
            popupElement.classList.remove("d-block");
            popupElement.classList.add("d-none");
          }
        });
        this.classList.add("active");
        const popup = document.querySelector(
          ".navbar-nav > li.active .subnav-content",
        );
        if (popup) {
          const popupElement = popup as HTMLElement;
          popupElement.classList.remove("d-none");
          popupElement.classList.add("d-block");
        }
      });
    });
  };

  useEffect(() => {
    toggleMenu();
  }, []);

  const toggleSubMenu = () => {
    const popup = document.querySelector(
      ".navbar-nav > li.active .subnav-content",
    );
    if (popup) {
      const popupElement = popup as HTMLElement;
      popupElement.classList.remove("d-block");
      popupElement.classList.add("d-none");
    }

    document.querySelectorAll(".navbar-nav > li").forEach((li) => {
      li.classList.remove("active");
    });
  };

  const toggleNav = () => {
    const sidenav = document.querySelector(".side-nav") as any;
    const mbottom = document.querySelector(".m-bottom") as any;
    const ainavbarheader = document.querySelector(".ainavbar-header") as any;
    const pagewrapper =
      document.querySelector(".page-wrapper") ||
      (document.querySelector(".dashboard-page-wrapper") as any);
    const pagecontect = document.querySelectorAll(".page-contect") as any;
    const menuName = document.querySelectorAll(".menu-name") as any;
    const greaterThan = document.querySelector(".greaterthan") as any;
    const lessThan = document.querySelector(".lessthan") as any;
    const headerTitle = document.querySelector(".header-title") as any;

    const isOpen = sidenav.style.width === "210px";
    const isHeaderOpen = ainavbarheader.style.width === "210px";
    headerTitle.style.setProperty("--content", isOpen ? '"ANL"' : '"ANLCRM"');
    sidenav.style.width = isOpen ? "60px" : "210px";
    mbottom.style.width = isOpen ? "60px" : "210px";
    pagewrapper.style.marginLeft = isOpen ? "60px" : "210px";
    ainavbarheader.style.width = isHeaderOpen ? "60px" : "210px";
    pagecontect.forEach((element: any) => {
      if (isOpen) {
        element.style.left = "60px";
      } else {
        element.style.left = "210px";
      }
    });
    menuName.forEach((element: any) => {
      if (isOpen) {
        element.style.transition = "0.5s";
        element.classList.remove("d-inline");
        element.classList.add("d-none");
      } else {
        element.style.transition = "0.5s";
        element.classList.remove("d-none");
        element.classList.add("d-inline");
      }
    });
    if (isOpen) {
      lessThan.classList.remove("d-block");
      lessThan.classList.add("d-none");
      greaterThan.classList.remove("d-none");
      greaterThan.classList.add("d-block");
    } else {
      lessThan.classList.remove("d-none");
      lessThan.classList.add("d-block");
      greaterThan.classList.remove("d-block");
      greaterThan.classList.add("d-none");
    }
  };

  const handleNavigate = (url: string) => {
    if (url) {
      toggleSubMenu();
      navigate(`${url}`);
    }
  };

  return (
    <>
      <div id="wrapper">
        <nav className="ainavbar" role="navigation">
          <div className="ainavbar-header" style={{ width: 210 }}>
            <button type="button" className="navbar-toggle">
              <IconComponent icon={CiMenuBurger} />
            </button>
            <h3 className="m-0 header-title"></h3>
          </div>
          <div className="d-flex align-items-center">
            <UserProfile />
          </div>
        </nav>
        <div className="collapse navbar-collapse navbar-ex1-collapse show">
          <ul
            className="nav navbar-nav side-nav"
            style={{ zIndex: 10, scrollbarWidth: "none", width: 210 }}
          >
            {filteredMenus.map((menu: any, index: any) => {
              const lastKey = MENUNAME?.slice()
                ?.reverse()
                ?.find((key: any) =>
                  filteredMenus?.some((m: any) => m?.key === key),
                );

              let isActive = menu?.key === baseKey;

              if (
                !isActive &&
                Array.isArray(menu?.quickMenu) &&
                menu?.quickMenu?.length > 0
              ) {
                isActive = menu?.quickMenu?.some(
                  (q: any) => q?.key === baseKey,
                );
              }

              if (
                !isActive &&
                Array.isArray(menu?.sections) &&
                menu?.sections?.length > 0
              ) {
                isActive = menu?.sections?.some(
                  (section: any) =>
                    Array.isArray(section?.children) &&
                    section?.children?.some(
                      (child: any) => child?.key === baseKey,
                    ),
                );
              }

              return (
                <li
                  className={`subnav ${isActive ? "active" : ""}`}
                  key={index}
                  onClick={toggleMenu}
                  style={{
                    marginBottom: filteredMenus?.length - 1 === index ? 55 : 0,
                    borderBottom:
                      menu.key === lastKey ? "1px solid lightgray" : "none",
                  }}
                >
                  <p
                    className="collapsed"
                    onClick={() =>
                      menu.key === "dashboard"
                        ? navigate("/")
                        : menu.quickMenu?.length < 1 &&
                            menu.sections?.length < 1
                          ? navigate(`/${menu?.key}`)
                          : null
                    }
                  >
                    <Tooltip
                      anchorElement="target"
                      position="right"
                      parentTitle={true}
                    >
                      <span title={menu.title} className="m-0">
                        {menu.icon}
                        <span className="menu-name">{menu.title || ""}</span>
                      </span>
                    </Tooltip>
                  </p>
                  {(menu.quickMenu?.length > 0 ||
                    menu.sections?.length > 0) && (
                    <div className="subnav-content page-contect">
                      <div className="container-fluid pb-3">
                        <div className="container-title">
                          <h2 className="fw-600">{menu.title} - Quick Menu</h2>
                          <button
                            className="model-close"
                            onClick={toggleSubMenu}
                          >
                            <IconComponent icon={ImCross} />
                          </button>
                        </div>
                        {menu.quickMenu?.length > 0 && (
                          <div className="quick-menu">
                            <div className="quick-menu-cards">
                              {menu.quickMenu.map((item: any) => (
                                <div
                                  key={item.key}
                                  className="quick-menu-card"
                                  onClick={() => handleNavigate(item.key)}
                                >
                                  <h5>{item.title}</h5>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        <div className="section-list">
                          {menu.sections?.map(
                            (section: any) =>
                              section.children?.length > 0 && (
                                <div key={section.title} className="section">
                                  <h4>{section.title}</h4>
                                  <ul>
                                    {section.children.map((child: any) => (
                                      <Tooltip
                                        key={child.key}
                                        anchorElement="target"
                                        position="top"
                                        parentTitle={true}
                                      >
                                        <li
                                          key={child.key}
                                          title={child.title}
                                          onClick={() =>
                                            handleNavigate(child.key)
                                          }
                                        >
                                          {child.title}
                                        </li>
                                      </Tooltip>
                                    ))}
                                  </ul>
                                </div>
                              ),
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </li>
              );
            })}
            <div className="m-bottom" onClick={toggleNav}>
              <span className="m-arrow">
                <IconComponent
                  icon={FaGreaterThan}
                  className="greaterthan d-none cursor-pointer"
                />
                <IconComponent
                  icon={FaLessThan}
                  className="lessthan cursor-pointer"
                />
              </span>
            </div>
          </ul>
        </div>
        {location.pathname === "/" ? (
          <div className="all-page">
            <div className="dashboard-page-wrapper">
              <Outlet />
            </div>
          </div>
        ) : (
          <div className="all-page">
            <div className="page-wrapper">
              <div className="page-information ">
                <Outlet />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Layout;
